import React from 'react';

/**
 * Shown while students are ticked: add them to any other custom group of
 * this school, or, when viewing a group, remove them from it.
 */
const SelectionBar = ({ count, targets, onAdd, inGroup, onRemove, onClear, busy }) => (
  <div className="td-selection" role="region" aria-label="Selected students">
    <span className="td-selection__count">{count} selected</span>
    {targets.length > 0 ? <span className="td-selection__label">Add to:</span> : null}
    {targets.map((group) => (
      <button
        key={group.id}
        type="button"
        className="td-selection__chip"
        disabled={busy}
        onClick={() => onAdd(group)}
      >
        {group.label}
      </button>
    ))}
    {inGroup ? (
      <button type="button" className="td-selection__remove" disabled={busy} onClick={onRemove}>
        Remove from this group
      </button>
    ) : null}
    <button type="button" className="td-selection__clear" disabled={busy} onClick={onClear}>Clear</button>
  </div>
);

export default SelectionBar;
